module.exports = __webpack_public_path__ + "img/mission_feedback_icon.d0a8acaa.svg";